module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("ForwardOption", "Would you like to forward this device, or claim it for yourself?") ))==null?'':__t)+
'</legend><div class="input"><div><input type="radio" name="prepaid-option" data-input="prepaid-option-radio" id="forward" value="forward" checked="checked"> <label for="forward">'+
((__t=( i18n.tc("ForwardOption", "Forward to someone else") ))==null?'':__t)+
'</label></div><div><input type="radio" name="prepaid-option" data-input="prepaid-option-radio" id="claim" value="claim"> <label for="claim">'+
((__t=( i18n.tc("ForwardOption", "Claim it for myself") ))==null?'':__t)+
'</label></div></div></fieldset><fieldset class="button-wrap"><button data-click="group-option-cancel">'+
((__t=( i18n.tc("ForwardOption", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="group-option-submit">'+
((__t=( i18n.tc("ForwardOption", "Next") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
